import React from 'react';
import { IonContent, IonPage, useIonRouter } from '@ionic/react';
import { useAlert } from 'utils/alert';
import { RouteComponentProps } from 'react-router';
import { Form, Input } from 'antd';
import { Button } from 'react-bootstrap';
import { analytics, axius, func, types } from 'utils';
import { Header, IonLoading, PhoneNumber } from 'components';
import { _store, _update } from '_Store';
import { faker } from '@faker-js/faker';

interface Props extends RouteComponentProps, types.StateProps {}
const Signup: React.FC<Props> = (props) => {
	const {
		__data: {
			settings: { countries },
		},
	} = _store.useState();

	const [form] = Form.useForm();
	const [presentAlert] = useAlert();
	const router = useIonRouter();

	const [loading, setLoading] = React.useState('');

	React.useEffect(() => {
		if (func.isLocal) {
			const name = faker.person.fullName();
			form.setFieldsValue({
				name,
				email: `${name.split(' ').join('-')}@gmail.com`.toLowerCase(),
				phoneNumber: `080${func.randomCode(8, ['n'])}`,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const submit = (v: any) => {
		v['phoneNumber'] = `+${
			countries?.find(
				(cnt: any) => cnt.code === (v.country || 'NG').toUpperCase()
			)?.callingCode
		}${v.phoneNumber.replace(/^0/, '')}`;
		setLoading('authenticating...');
		axius.post('auth/signup', { ...v }).then((res: types.AxiusResponse) => {
			if (res.status === 201) {
				analytics.trackEvent(analytics.eventTypes.SIGN_UP, v);
				_update.auth('user', res.data);
				_update.auth('token', '');
				func.init();
				router.push('/verify');
			} else {
				presentAlert(res.message);
			}
			setLoading('');
		});
	};

	return (
		<IonPage id="Signup" className="ph-no-capture">
			<Header
				{...props}
				showSearch={false}
				showSegments={false}
				goBack={() => props.history.replace('/user')}
				showAddress={false}
			/>
			<IonContent fullscreen={false}>
				<IonLoading
					open={loading ? true : false}
					message={loading}
					onCancel={() => setLoading('')}
				/>

				<div className="p-3">
					{/* <img
						src={images.Logo}
						alt="Republic Dash"
						style={{ width: 50 }}
						className="mb-2"
					/> */}
					<h3 className="mb-0">
						<b>Create an Account</b>
					</h3>
					<div className="text-muted">Let's get you started.</div>
					<div>&nbsp;</div>

					<Form form={form} layout="vertical" onFinish={submit}>
						<Form.Item
							label="Full name"
							name="name"
							rules={[func.requiredInput]}
						>
							<Input type="text" size="large" placeholder="Arinola Soyinka" />
						</Form.Item>
						<Form.Item
							label="Email address"
							name="email"
							rules={[func.requiredInput]}
						>
							<Input
								type="email"
								size="large"
								placeholder="arinola@gmail.com"
							/>
						</Form.Item>
						<PhoneNumber {...props} form={form} />
						<div>&nbsp;</div>

						<Button
							type="submit"
							variant="secondary btn-block btn-md text-uppercases"
							style={{ height: 49 }}
						>
							Signup
						</Button>
						<div>&nbsp;</div>

						<div
							className="text-centers mt-2 text-muted small"
							onClick={() => router.push('/login')}
						>
							Already have an account? <b className="primary">Sign in</b>
						</div>
					</Form>
				</div>
				<div>&nbsp;</div>
				<div>&nbsp;</div>
				<div>&nbsp;</div>
			</IonContent>
		</IonPage>
	);
};

export default Signup;
